/**************************************************************************************************/
/*   File: /src/app/shared/enums/file.type.enum.ts                                                */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The file type enum
 */
export enum FileType {
    /**
     * File upload type for authorization
     */
    AUTHORIZATION = 'authorization',
    /**
     * File upload type for geometries
     */
    GEOMETRIES = 'geometries',
    /**
     * File upload type for rules
     */
    RULES = 'rules',
    /**
     * File upload type others
     */
    OTHERS = 'others'
}